var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiRinline = function SvgAiRinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1092_13245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.77 9.445h-2.352V7.094a.393.393 0 0 0-.388-.388h-2.577a.393.393 0 0 0-.388.388v2.351H7.713a.393.393 0 0 0-.388.388v2.578c0 .194.162.388.388.388h2.352v2.351c0 .194.161.388.388.388h2.577a.393.393 0 0 0 .388-.388V12.8h2.352a.393.393 0 0 0 .387-.388V9.833a.417.417 0 0 0-.387-.388Z",
    fill: "#D9516C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.73 24.5-.461-.25C2.259 19.28 2 11.183 2 10.835v-8.38h.889c5.18 0 8.347-1.72 8.38-1.737L11.657.5l.404.178c3.975 1.753 8.444 1.56 8.492 1.56l.93-.05v9.027c0 7.103-8.93 12.768-9.31 13.01l-.444.275ZM3.777 4.217v6.602c0 .275.258 7.135 7.887 11.604 1.729-1.196 8.04-5.907 8.04-11.208v-7.2c-1.56-.024-4.824-.25-7.976-1.551-1.002.468-3.806 1.6-7.96 1.745l.009.008Z",
    fill: "#4A4A4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1092_13245"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgAiRinline;